import styles from './Table.module.css';

export function columnClassName(type: string) {
  const className = `data-${type}`;
  if (className in styles) {
    return styles[className];
  }
  return null;
}
